import makeEnum from '../util/makeEnum';

export const catererReportStatusEnum = makeEnum('COMPLETED', 'DOWNLOADED', 'PROCESSING');
export const daysOfTheWeekEnum = makeEnum(
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
);
export const lineItemTypeEnum = makeEnum(
  'DELIVERY_FEE',
  'MISC_FEE',
  'DISCOUNT',
  'EZ_REWARDS_CREDIT',
  'SALES_TAX',
  'SALES_TAX_ADJUSTMENT',
  'SALES_TAX_REMITTANCE',
  'CREDIT_CARD_FEE',
  'COMMISSION',
  'ADJUSTMENT',
  'PROMO',
  'MARKETPLACE_FEES_TAX'
);
export const orderSourcesEnum = makeEnum('MARKETPLACE', 'EZ_ORDERING', 'DIRECT_ENTRY', 'CLUB_SODA');
export const orderTypesEnum = makeEnum('DELIVERY', 'TAKEOUT', 'THIRD_PARTY_DELIVERY');
export const paymentMethodEnum = makeEnum(
  'CREDIT_CARD',
  'IN_STORE',
  'INVOICE',
  'LINE_OF_CREDIT',
  'HOUSE_ACCOUNT'
);
export const rejectReasonsEnum = makeEnum(
  'UNABLE_TO_DELIVER',
  'UNABLE_TO_PREPARE',
  'LOCATION_CLOSED',
  'OTHER'
);
export const changeRejectReasonsEnum = makeEnum('REQUEST_CHANGE', 'UNABLE_TO_DELIVER', 'OTHER');
export const requestModificationReasonsEnum = makeEnum(
  'ITEM_UNAVAILABLE',
  'PRICE_ADJUSTMENT',
  'DELIVERY_TIME',
  'REQUEST_EZDISPATCH',
  'CHANGE_STORE',
  'REQUEST_CLARIFICATION',
  'REQUEST_EZDISPATCH_WHENEVER',
  'OTHER'
);
export const timespanEnum = makeEnum('WEEK', 'MONTH', 'YEAR');
export const deliveryTimeFeedbackEnum = makeEnum('EARLY', 'ON_TIME', 'LATE');
export const deliveryProfessionalismFeedbackEnum = makeEnum(
  'HIGHLY_UNPROFESSIONAL',
  'UNPROFESSIONAL',
  'NEUTRAL',
  'PROFESSIONAL',
  'HIGHLY_PROFESSIONAL'
);
export const lineItemPercentType = makeEnum('FOOD');

export const phoneLabelsEnum = makeEnum(
  'PHONE',
  'MOBILE',
  'WORK',
  'HOME',
  'OFFICE',
  'KITCHEN',
  'CATERING',
  'STORE',
  'DIRECT_ENTRY'
);

export const portalStatusEnum = makeEnum(
  'NO_ACCOUNT',
  'NEEDS_ACTIVATION',
  'ACTIVE',
  'PASSWORD_RESET',
  'DEACTIVATED'
);

export const accountStatusFilterEnum = makeEnum(
  'ACTIVE',
  'INACTIVE',
  'INVITED',
  'NO_ACCOUNT',
  'NON_DEACTIVATED'
);

export const scopedActivationPermissionErrorEnum = makeEnum(
  'BRAND_ADMIN',
  'MISSING_STORES',
  'NOT_AUTHORIZED'
);

export const deliveryStatusEnum = {
  EZ_DISPATCH_ACCEPTED: 'ezDispatch Accepted',
  EZ_DISPATCH_REJECTED: 'ezDispatch Rejected',
  EZ_DISPATCH_CANCELLED: 'ezDispatch Cancelled',
  EZ_DISPATCH_REQUESTED: 'ezDispatch Requested',
  DELIVERY: 'Delivery',
  TAKEOUT: 'Takeout',
  EZ_DISPATCH: 'ezDispatch',
};

export const deliveryStatusDisplayEnum = {
  [deliveryStatusEnum.EZ_DISPATCH_ACCEPTED]: 'Dispatch Accepted',
  [deliveryStatusEnum.EZ_DISPATCH_REJECTED]: 'Dispatch Rejected',
  [deliveryStatusEnum.EZ_DISPATCH_CANCELLED]: 'Dispatch Cancelled',
  [deliveryStatusEnum.EZ_DISPATCH_REQUESTED]: 'Dispatch Requested',
  [deliveryStatusEnum.EZ_DISPATCH]: 'Dispatch',
  [deliveryStatusEnum.DELIVERY]: 'Delivery',
  [deliveryStatusEnum.TAKEOUT]: 'Takeout',
};

export const operatingScheduleEnum = makeEnum('DELIVERY', 'TAKEOUT');

export const leadTimeTypesEnum = makeEnum('sameDay', 'dayBefore', 'manyDays');
export const orderSupportTypesEnum = makeEnum(
  'orderModifications',
  'customerClarifications',
  'contactEzCater'
);
